import React from "react";
import { surveyFormUrl } from "./Config";

const submitSurveyCustomForm = async (url, body, setSuccessMsg, setErrorMsg) => {
  //let body = JSON.stringify(values);
  fetch(url, {
    method: "POST",
    body: body
  }).then(response => response.text())
    .then(result => {
      let data = JSON.parse(result);
      if (data.status === "validation_failed") {
        setErrorMsg(data.message);
      } else {
        setSuccessMsg(data.message);
        window.scrollTo(0, 0);
      }
    })
    .catch(error => console.log('Error sending form', error));
};

const submitSurveyForm = async (values, setSuccessMsg, setErrorMsg) => {
  let body = JSON.stringify(values);
  fetch(surveyFormUrl, {
    method: "POST",
    body: body
  })
    .then(function (response) {
      return response.text();
    })
    .then(function (body) {
      let data = JSON.parse(body);
      if (data.error && data.message) {
        setErrorMsg(data.message);
      }
      if (data.success) {
        setSuccessMsg("ยินดีด้วย!");
        window.scrollTo(0, 0);
      }

    })
    .catch(function (error) {
      console.log('Send Request failed', error);
    });
};

export { submitSurveyForm, submitSurveyCustomForm };
